import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const handleLogin = (e) => {
        e.preventDefault();
        alert(`Login dengan email: ${email}`);
    };

    return (
        <div className="container">
            <Header />
            <h2>Login</h2>
            <form onSubmit={handleLogin}>
                <input type="email" placeholder="Email" className="form-control mb-2"
                    value={email} onChange={(e) => setEmail(e.target.value)} required />
                <input type="password" placeholder="Password" className="form-control mb-2"
                    value={password} onChange={(e) => setPassword(e.target.value)} required />
                <button type="submit" className="btn btn-primary col-sm-12 mb-2">Login</button>

                <center>
                    <a style={{
                        width: "100%",
                        padding: "20px",
                        border: "none",
                        color: 'red',
                        cursor: "pointer",
                        borderRadius: "5px",
                        fontSize: "16px",
                        marginTop: "10px",
                    }} className="text-center" onClick={() => {
                        navigate('/register')
                    }}>Kembali ke halaman utama</a>
                </center>
            </form>
        </div >
    );
};

export default Login;
